export default "__VITE_ASSET__9fr$E7Pe__"